import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ConversationAgentEntity } from './conversation-agent.entity';

@Entity('_conversation_agent_daily_usage')
@Index(['date', 'conversationAgentId'], { unique: true })
export class ConversationAgentDailyUsageEntity extends BaseEntity {
	// Time Period
	@Column({ type: 'date' })
	public date!: Date;

	@Column({ type: 'int', unsigned: true })
	public year!: number;

	@Column({ type: 'int', unsigned: true })
	public month!: number;

	@Column({ type: 'int', unsigned: true })
	public dayOfMonth!: number;

	@Column({ type: 'int', unsigned: true })
	public dayOfWeek!: number; // 0=Sunday, 1=Monday, ..., 6=Saturday

	@Column({ type: 'enum', enum: ['weekday', 'saturday', 'sunday'] })
	public dayType!: 'weekday' | 'saturday' | 'sunday';

	// Usage Metrics
	@Column({ type: 'int', unsigned: true, default: 0 })
	public voiceSeconds!: number;

	@Column({ type: 'int', unsigned: true, default: 0 })
	public llmTokens!: number;

	/*
	 * PD-16963: the day's agent-turn usage split the way it is billed, summed
	 * from the `_conversation_message` columns of the same names, so the day
	 * compares across providers and models. `promptTokens` is the whole prompt;
	 * `cachedTokens` (cache reads) and `cacheCreationTokens` (cache writes) are
	 * parts of it. NULL means not measured (days before the columns existed, or
	 * before the PD-14421 message telemetry), never zero.
	 */
	@Column({ type: 'int', unsigned: true, nullable: true })
	public promptTokens!: number | null;

	@Column({ type: 'int', unsigned: true, nullable: true })
	public completionTokens!: number | null;

	@Column({ type: 'int', unsigned: true, nullable: true })
	public cachedTokens!: number | null;

	@Column({ type: 'int', unsigned: true, nullable: true })
	public cacheCreationTokens!: number | null;

	/** Provider cost in USD of the day's agent turns: the sum of `_conversation_message.llm_cost`. */
	@Column({ type: 'decimal', precision: 12, scale: 6, nullable: true })
	public llmCost!: number | null;

	@Column({ type: 'int', unsigned: true, default: 0 })
	public totalVoice!: number;

	@Column({ type: 'int', unsigned: true, default: 0 })
	public totalChats!: number;

	// Required: Per-Agent (NOT nullable)
	@Column({
		name: '_fk__conversation_agent__id',
		type: 'int',
		unsigned: true,
	})
	public conversationAgentId!: number;

	@ManyToOne(() => ConversationAgentEntity)
	@JoinColumn({ name: '_fk__conversation_agent__id' })
	public conversationAgent?: ConversationAgentEntity;
}
